export const topCatKeyboard_ADA = () => {
    let topCatLink = '#main-nav ul li a',
            subCatLink = '#main-nav ul.children li a';
    $(topCatLink).not(subCatLink).each(function () {
        $(this).attr('aria-role', 'link');
        $(this).attr('aria-title', $(this).data('twist'));
    });
    const mainNavEnter_ADA = () => {
        $(topCatLink).not(subCatLink).off('keydown');
        $(topCatLink).not(subCatLink).on('keydown', function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                if ($('ul.children').is(':visible')) $('ul.children:visible').parents('li').trigger('mouseout');
                $(this).parents('li').trigger('mouseover');
                $(this).off('keydown');
            }
        });
    }
    $('#main-nav ul li').not('#main-nav ul.children li').on('mouseout', function (e) {
        mainNavEnter_ADA();
    });
}